module.exports = __webpack_public_path__ + "static/img/img-educator-feature-1@3x.9bbd042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-1@3x.png
// module id = pT9Q
// module chunks = 18